import Tester from './tester';
export default Tester;